const layers = [
  "conv2d0",
  "conv2d1",
  "conv2d2",
  "mixed3a",
  "mixed3b",
  "mixed4a",
  "mixed4b",
  "mixed4c",
  "mixed4d",
  "mixed4e",
  "mixed5a",
  "mixed5b",
]

export const encode = (type, layer, neuron) => {
  return (
    "#" +
    type +
    layers
      .indexOf(layer)
      .toString(16)
      .padStart(2, 0) +
    neuron.toString(16).padStart(3, 0)
  )
}

export const decoder = str => {
  const noHash = str.slice(1)
  const type = noHash[0]
  const layerIndex = parseInt(noHash.slice(1, 3), 16)
  const neuron = parseInt(noHash.slice(-3), 16)

  return { type, layer: layers[layerIndex], neuron }
}
